module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('br'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("CLIENT DETAILS")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("PROJECT MODULE")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Client")]), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "items": _vm.setupClients,
      "label": "Client",
      "item-text": "client_name",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.setupClient),
      callback: function($$v) {
        _vm.setupClient = $$v
      },
      expression: "setupClient"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Initialize Project Module")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "label": "Create an instance of Project Module for the MyOrder instance"
    },
    model: {
      value: (_vm.setupProjectModule),
      callback: function($$v) {
        _vm.setupProjectModule = $$v
      },
      expression: "setupProjectModule"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("SUPER USER DETAILS")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Name")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Name",
      "solo": ""
    },
    model: {
      value: (_vm.setupName),
      callback: function($$v) {
        _vm.setupName = $$v
      },
      expression: "setupName"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Surname")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Surname",
      "solo": ""
    },
    model: {
      value: (_vm.setupSurname),
      callback: function($$v) {
        _vm.setupSurname = $$v
      },
      expression: "setupSurname"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Email")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Email",
      "solo": ""
    },
    model: {
      value: (_vm.setupEmail),
      callback: function($$v) {
        _vm.setupEmail = $$v
      },
      expression: "setupEmail"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Password")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Password",
      "type": "password",
      "solo": ""
    },
    model: {
      value: (_vm.setupPassword),
      callback: function($$v) {
        _vm.setupPassword = $$v
      },
      expression: "setupPassword"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Confirm Password")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Password Confirm",
      "type": "password",
      "solo": ""
    },
    model: {
      value: (_vm.setupPasswordConfirm),
      callback: function($$v) {
        _vm.setupPasswordConfirm = $$v
      },
      expression: "setupPasswordConfirm"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-4 pb-4 buttonHolder"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success",
      "disabled": _vm.fncCheckDisable()
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncSetup.apply(null, arguments)
      }
    }
  }, [_vm._v("Create")])], 1)]), _vm._v(" "), _c('v-flex', {
    staticClass: "requiredMessage",
    attrs: {
      "lg12": ""
    }
  }, [_c('small', [_c('strong', [_vm._v(" ")])])])], 1)], 1)
},staticRenderFns: []}